import { useCallback, useState } from 'react';

interface UseVisitCommentResult {
  isExpanded: boolean;
  isTruncated: boolean;
  toggleHandler(): void;
  ellipsisHandler(isEllipsis: boolean): void;
}

// Состояние одного комментария в истории визитов. `isTruncated` приходит из
// замера Typography.Paragraph: при `expanded: true` замер отключается и
// `onEllipsis` больше не вызывается (antd 5.27, Base/index.js:148,346), поэтому
// в раскрытом виде значение сохраняется и кнопка «Свернуть» не пропадает.
export const useVisitComment = (): UseVisitCommentResult => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);

  const toggleHandler = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const ellipsisHandler = useCallback((isEllipsis: boolean) => {
    setIsTruncated(isEllipsis);
  }, []);

  return {
    isExpanded,
    isTruncated,
    toggleHandler,
    ellipsisHandler,
  };
};
